import { ApiClient } from "../ApiClient";

/**
 * Helper to generate custom headers for document options
 */
const getDocumentHeaders = (options = {}, extraHeaders = {}) => {
  const headers = { ...extraHeaders };
  if (options.includeMetrics) {
    headers["X-Include-Metrics"] = "true";
  }
  return headers;
};

export const getDocument = async (url, documentId) => {
  // Overriding Content-Type to application/pdf as required by this specific endpoint
  return ApiClient.get(`${url}/${documentId}`, {
    "Content-Type": "application/pdf",
  });
};

export const updateDocument = async (url, documentId, data, options = {}) => {
  const headers = getDocumentHeaders(options);
  return ApiClient.put(`${url}/${documentId}`, data, headers);
};

export const updateDocumentWithFile = async (
  url,
  documentId,
  formData,
  options = {},
) => {
  const headers = getDocumentHeaders(options);
  // ApiClient handles FormData automatically (removes JSON content-type)
  return ApiClient.put(`${url}/${documentId}`, formData, headers);
};

export const getDocumentList = (url, filingId) => {
  return ApiClient.get(`${url}/${filingId}`);
};

export const createAndGetDocument = async (
  url,
  filingId,
  data,
  options = {},
) => {
  const headers = getDocumentHeaders(options);
  return ApiClient.post(`${url}/${filingId}`, data, headers);
};

export const createCryptoOriginDocument = async (
  file,
  exchange,
  reportYear,
  processInfo = null,
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("exchange", exchange);
  formData.append("source", "tax");
  formData.append("report_year", reportYear);

  if (processInfo) {
    try {
      formData.append("process_id", JSON.stringify(processInfo));
    } catch (error) {
      console.error("Failed to serialize process_id payload", error);
    }
  }

  return ApiClient.post("/crypto/origin-document", formData);
};

export const getCryptoOriginDocuments = async (
  reportYear,
  exchange,
  source = "tax",
  processInfo = null,
) => {
  const params = new URLSearchParams({
    report_year: reportYear,
    exchange: exchange,
    source: source,
  });

  if (processInfo) {
    try {
      params.set("process_id", JSON.stringify(processInfo));
    } catch (error) {
      console.error(
        "Failed to serialize process_id payload for listing",
        error,
      );
    }
  }

  return ApiClient.get(`/crypto/origin-document?${params.toString()}`);
};

export const getCryptoOriginDocument = async (documentId) => {
  return ApiClient.get(`/crypto/origin-document/${documentId}`);
};

export const deleteDocument = async (url, documentId, options = {}) => {
  const headers = getDocumentHeaders(options);
  return ApiClient.delete(`${url}/${documentId}`, headers);
};

export const generateCryptoGainLoss = async (
  year,
  objectId,
  costBasisMethod,
) => {
  const data = {
    year: year,
    object_id: objectId,
    cost_basis_method: costBasisMethod,
    model_flag: "TF",
  };

  return ApiClient.post("/crypto/gain-loss", data);
};
